module.exports = () => `composer require flagsmith/flagsmith-php-client
`
